import { Grid, Modal, TextField, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ModalEditar = ({
  open,
  setOpen,
  agency,
  updateMaxDailyAmountByPdv,
  handleSetAmountReceived,
  newMaxAmount,
  formattedAmountReceived,
  helperTextMessage
}) => {

  if (!agency) return null;

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid
        container
        sx={{
          backgroundColor: "#fff",
          padding: 3,
          borderRadius: 2,
          width: 400,
          margin: "10% auto",
          position: "relative"
        }}
      >
        <Button
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            minWidth: "unset",
            padding: 0,
            color: "#888"
          }}
        >
          <CloseIcon />
        </Button>
        <h2>Editar Agencia {agency.puntoDeVenta}-{agency.maquina}</h2>

        <TextField
          fullWidth
          label="Importe diario máximo actual"
          disabled
          defaultValue={agency.maxImporteDiario?.toLocaleString("es-AR", {
            style: "currency",
            currency: "ARS",
            currencyDisplay: "symbol",
          })}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Nuevo importe diario máximo"
          value={formattedAmountReceived === "" ? " $ 0,00" : formattedAmountReceived}
          onChange={handleSetAmountReceived}
          sx={{ mb: 2 }}
          helperText={
            helperTextMessage != "" 
              ? helperTextMessage : "Coma o Punto para habilitar/deshabilitar decimales"
          }
        />

        <Button variant="contained" onClick={() => {
          updateMaxDailyAmountByPdv({ ...agency, newAmount: newMaxAmount });
        }}>
          Solicitar
        </Button>
      </Grid>
    </Modal>
  );
};

export default ModalEditar;
